import React, { useEffect, useState, useLayoutEffect } from 'react';
import { Collapse } from 'antd';
import styles from './MobileCollapseList.module.scss';
import classNames from 'classnames';
import Link from 'next/link';
import {
  MenuItem,
  MenuListProps,
  CollapseListProps,
  CollapseItem,
  currentItem
} from './MobileCollapseList.types';
import { useRouter } from 'next/router';
import Image from 'next/image';
import StickyCollapseList from '../StickyCollapseList';
import { useLanguage } from '@/hooks/use-language';

const MenuList: React.FC<MenuListProps> = ({ menuList, articleUrl }) => {
  const language = useLanguage();
  return (
    <>
      {menuList.map((item: MenuItem, index: number) => {
        return (
          <Link
            key={index}
            href={{
              pathname: `/${language}/blog/guide${item.blog[0]?.url}`
            }}
            onClick={e => {
              window?.dataLayer?.push({
                event: 'buttonClick',
                buttonTitle: 'content_nav_article',
                description: item?.blog_title || item.blog[0]?.title,
                pageURL: window.location.href,
                componentName: 'content nav'
              });
            }}
          >
            <div
              className={classNames(
                styles.menu_item,
                `/${articleUrl}/` === item.blog[0]?.url && styles.active
              )}
            >
              {item?.blog_title || item.blog[0]?.title}
            </div>
          </Link>
        );
      })}
    </>
  );
};

const CollapseList: React.FC<CollapseListProps> = props => {
  const {
    data: { title, url, table_of_content_entry: collapseList }
  } = props;
  const router = useRouter();
  const language = useLanguage();
  const articleUrl = router.query.article as string;
  const [activeCollaspeIndex, setActiveCollaspeIndex] = useState(0);
  const [currentItem, setCurrentItem] = useState<currentItem | undefined>();
  const [showStickyBar, setShowStickyBar] = useState(false);

  const expandCollapse = (e: string | any[]) => {
    // 如果全部收起了，根据是否是文章页，修改外层title
    if (e.length === 0) {
      setActiveCollaspeIndex(0);
    } else {
      // 展开对应章节
      setActiveCollaspeIndex(Number(e[1]));
    }
  };

  // 点击exoandIcon时正确冒泡，不跳到link事件
  const clickIcon = () => {};

  useEffect(() => {
    // 根据article url 寻找当前的其父级目录
    const activeCollaspeIndex =
      collapseList.findIndex(item => {
        return item.blog_post.some(blogItem =>
          blogItem.blog.some(innerBlogItem => innerBlogItem?.url === `/${articleUrl}/`)
        );
      }) + 1;
    // 根据article url 寻找当前的文章对象
    const activeItem = collapseList[activeCollaspeIndex - 1]?.blog_post.find(item => {
      return item?.blog[0]?.url === `/${articleUrl}/`;
    });
    // 设置当前对象，用于collapse title显示
    if (activeCollaspeIndex > 0) {
      setCurrentItem({
        index: activeCollaspeIndex,
        collapseTitle: collapseList[activeCollaspeIndex - 1]?.category_title,
        articleTitle: activeItem?.blog_title || (activeItem?.blog[0].title as string)
      });
    }

    setActiveCollaspeIndex(activeCollaspeIndex);
  }, [articleUrl]);

  const changeCollapse = () => {
    let element = document?.getElementById('scrolling-element')?.getBoundingClientRect();
    setShowStickyBar(Number(element?.bottom) <= 0);
  };

  useLayoutEffect(() => {
    window.addEventListener('scroll', changeCollapse);
    return () => window.removeEventListener('scroll', changeCollapse);
  }, []);

  const items = collapseList?.map((item: CollapseItem, index: number) => ({
    key: index + 1,
    label: (
      <p
        className={styles.collapse_label}
        onClick={e => {
          window?.dataLayer?.push({
            event: 'buttonClick',
            buttonTitle: 'content_nav_article',
            description: item.category_title,
            pageURL: window.location.href,
            componentName: 'content nav'
          });
        }}
      >
        <span className={styles.collapse_label_index}>{index + 1}</span>
        <span>{item.category_title}</span>
      </p>
    ),
    children: <MenuList menuList={item.blog_post} articleUrl={articleUrl} />
  }));

  return (
    <>
      <StickyCollapseList data={props.data} isShow={showStickyBar} />
      <div className={classNames(styles.mobile_wrapper)} id="scrolling-element">
        <Collapse
          className={styles.mobile_collapse}
          ghost
          expandIconPosition={'end'}
          expandIcon={({ isActive }) => (
            <div className={styles.mobile_collapse_icon_wrapper}>
              <Image
                src="/blog/icon/Left.svg"
                alt={''}
                width={10}
                height={6}
                className={isActive ? styles.collapse_icon_up : styles.collapse_icon_down}
              />
            </div>
          )}
          items={[
            {
              key: 0,
              label: (
                <>
                  {/* 外层collapse的title */}
                  {currentItem ? (
                    <div className={styles.collapse_title_wrapper}>
                      <p className={styles.collapse_title}>
                        <span className={styles.index}>{currentItem.index}</span>
                        {currentItem.collapseTitle}
                      </p>
                      <p className={styles.collapse_sub_title}>{currentItem.articleTitle}</p>
                    </div>
                  ) : (
                    <div>{title}</div>
                  )}
                </>
              ),
              children: (
                <div className={styles.expand_wrapper}>
                  <Link
                    href={{ pathname: `/${language}/blog/guide${url}` }}
                    onClick={e => {
                      window?.dataLayer?.push({
                        event: 'buttonClick',
                        buttonTitle: 'content_nav_article',
                        description: title,
                        pageURL: window.location.href,
                        componentName: 'content nav'
                      });
                    }}
                  >
                    <div
                      className={classNames(
                        styles.menu_item_all,
                        `/${articleUrl}/` === url && styles.active
                      )}
                    >
                      {title}
                    </div>
                  </Link>
                  <div className={styles.sub_callapse_wrapper}>
                    <Collapse
                      activeKey={activeCollaspeIndex}
                      ghost
                      items={items}
                      expandIconPosition={'end'}
                      expandIcon={({ isActive }) => (
                        <>
                          {isActive ? (
                            <Image
                              src="/blog/icon/Left.svg"
                              alt={''}
                              width={8}
                              height={4}
                              className={styles.collapse_icon_up}
                              onClick={() => clickIcon()}
                            />
                          ) : (
                            <Image
                              src="/blog/icon/Left.svg"
                              alt={''}
                              width={8}
                              height={4}
                              className={styles.collapse_icon_down}
                              onClick={() => clickIcon()}
                            />
                          )}
                        </>
                      )}
                      // 目录栏点击事件
                      onChange={e => expandCollapse(e)}
                    />
                  </div>
                </div>
              )
            }
          ]}
        ></Collapse>
      </div>
    </>
  );
};

export default CollapseList;
